<script lang="ts">
export function avatarInitials(name: string): string {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => [...w][0]!.toUpperCase()).join('\u200C') || '?'
}
</script>

<script setup lang="ts">
/** Initials on a colour derived from the name: the same person keeps the same colour. */
import { computed } from 'vue'

const p = withDefaults(defineProps<{ name: string; size?: number }>(), { size: 28 })
/*
 * Joined by a zero-width non-joiner: two Arabic letters side by side would
 * otherwise join cursively into a word that is not the person's initials.
 */
const initials = computed(() => avatarInitials(p.name))
const hue = computed(() => [...p.name].reduce((s, c) => s + c.charCodeAt(0), 0) % 6 + 1)
</script>

<template>
  <span aria-hidden="true" :style="{ width: `${size}px`, height: `${size}px`, fontSize: `${Math.round(size * 0.4)}px`,
                                     background: `hsl(var(--chart-${hue}) / .16)`, color: `hsl(var(--chart-${hue}))` }"
        class="inline-grid flex-none place-items-center rounded-pill font-semibold">{{ initials }}</span>
</template>
